
import Image from "@/components/Atoms/Image";

interface Props {
  data: any;
  layout: string;
}

export function IconGallery({ data, layout }: Props) {

  if (layout == "tRight") {
    return (
      <div className="iconGallery absolute right-12 top-12 flex flex-row gap-4 z-10">
        {data.map((entry: any, i: number) => (
          <Image data={entry} className={"max-w-[4.5rem] md:max-w-[7.5rem]"} />
        ))}
      </div>
    );
  } else if (layout == "bRight") {
    return (
      <div className="iconGallery absolute right-8 top-6 md:top-[unset] md:bottom-16 flex flex-row gap-4 z-10">
        {data.map((entry: any, i: number) => (
          <Image data={entry} className={"max-w-[4.5rem] md:max-w-[7.5rem]"} />
        ))}
      </div>
    );
  } else {
    return (
      <div className="iconGallery absolute right-6 top-6 md:top-[unset] md:bottom-16 flex flex-row gap-4 z-10">
        {data.map((entry: any, i: number) => (
          <Image
            key={i}
            data={entry}
            className={"max-w-[4.5rem] md:max-w-[7.5rem]"}
          />
        ))}
      </div>
    );
  }
}
